import { useState, useEffect } from 'react';

const getFlags = (width) => {
    return {
        isMobile: width < 640,
        isTablet: width >= 640 && width < 1023,
        isDesktop: width >= 1024 && width < 1280,
        isXL: width >= 1280,
    };
};

const useResponsiveFlags = () => {
    const [flags, setFlags] = useState(() => {
        if (typeof window === 'undefined') return { isMobile: false, isTablet: false, isDesktop: true, isXL: false };
        return getFlags(window.innerWidth);
    });

    useEffect(() => {
        const handleResize = () => {
            setFlags(getFlags(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // run on mount

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return flags;
};

export default useResponsiveFlags;
